import { z } from "zod";
import { animeSummarySchema } from "./anime.js";
/** Set-once-plus-one-edit, then locked — see RecommendationService.setPreferences. */
export const GENRE_PREFERENCES_MAX_SETS = 2;
/** The genres a user has explicitly picked as favourites. */
export const genrePreferencesSchema = z.object({
    genreIds: z.array(z.number().int()),
    /** How many more times `PUT /me/genre-preferences` will succeed — 0 means
     * the picker is locked (the initial pick and its one edit are both used). */
    remainingEdits: z.number().int().nonnegative(),
});
export const setGenrePreferencesInputSchema = z.object({
    genreIds: z.array(z.number().int()).max(30),
});
/** A personalised or similarity-based rail — rotates day to day. */
export const recommendationResponseSchema = z.object({
    items: z.array(animeSummarySchema),
    /** A short, per-title explanation of the match. */
    itemReasons: z.array(z.object({ animeId: z.number().int(), text: z.string().max(180) })).optional(),
    /** Why these were picked, for a light "подобрано по …" caption. */
    basis: z.enum(["liked", "preferences", "history", "genre", "trending"]),
});
/** Titles explicitly picked as "I like this" on the recommendations setup
 * page — a stronger taste signal than inferring genres from the library. */
export const likedAnimeResponseSchema = z.object({
    items: z.array(animeSummarySchema),
});
/** Whether the visitor has configured recommendations at all yet (explicit
 * genres or liked titles) — drives the unobtrusive header nudge. */
export const recommendationsStatusSchema = z.object({
    configured: z.boolean(),
});
//# sourceMappingURL=recommendations.js.map